module.exports = __webpack_public_path__ + "img/necklace.a10cb604.svg";